module.exports = __webpack_public_path__ + "img/details4.cdad47d0.png";